import React, { useEffect, useState } from 'react';

import {InputNumber, Table} from 'antd';
// import {InputQuantidade} from './input-quantidade.jsx.old';
import './tabela-itens.scss';
import {Dinheiro} from '@contentsys/contentsys-react-components';

const TabelaItens = (props) => {

    const {onChangeCredito} = props;
    

    const changeQtdDevolver = (record, index) => (newValue) => {
        
        console.log(record.quantidade, record.qtdDevolvida, newValue);

        if((record.quantidade - record.qtdDevolvida) >= newValue){


            const newData = [...itensADevolver];
    
            newData[index].credito = newValue * (record.totalItem / record.quantidade);
            newData[index].qtdDevolver = newValue;
            setItensADevolver(newData);

            onChangeCredito && onChangeCredito(newData);
        } else {
            alert("Valor maior que o permitido");
        }
              

    }

  

    const columns = [{
        title: 'Produto',
        dataIndex: 'produto',
        key: 'produto'
    },
    {
        title: 'Quantidade',
        dataIndex: 'quantidade',
        key: 'quantidade'
    },{
        title: 'Valor Un',
        dataIndex: 'valorUn',
        key: 'valorUn'
    },
    {
        title: 'Descontos',
        dataIndex: 'descontos',
        key: 'descontos'
    },
    {
        title: 'Total',
        dataIndex: 'totalItem',
        key: 'totalItem'
    },
    {
        title: 'Devolver',
        dataIndex: 'qtdDevolver',
        key: 'qtdDevolver',
        render: (text, record, index) => {

            console.log(record);
            if(record.qtdDevolvida == record.quantidade){
                return <></>
            }
            return <InputNumber onChange={changeQtdDevolver(record, index)} decimalSeparator="," defaultValue={0} keyboard={true} min={0} max={record.quantidade - record.qtdDevolvida}></InputNumber>;
        }
    },{
        title: 'Ja Devolvido',
        dataIndex: 'qtdDevolvida',
        key: 'qtdDevolvida',
        
    }, {
        title: 'Credito',
        dataIndex: 'credito',
        key: 'credito',
        render: (text, record) => {
            return <Dinheiro decimalSeparator="," value={( record.credito || 0)}></Dinheiro>;
        }
    }]

    const {dadosVenda} = props;

    let itens = (dadosVenda == null)? [] : dadosVenda.itens;

    let [itensADevolver, setItensADevolver] = useState([]);

    useEffect(()=> {
        setItensADevolver(itens);
    }, itens);

    console.log("dados", dadosVenda);

    return  <Table columns={columns} 
                  dataSource={itensADevolver} 
                  style={{width: '100%'}}
                  pagination={false}
                  rowKey="uuid"
                  rowClassName={(record) => {
                      if(record.quantidade - record.qtdDevolvida == 0){
                          return "totalmenteDevolvido"
                      }
                  }}
            ></Table>;
}

export {TabelaItens};